import React from "react";
import SubTitle from "./SubTitle";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
// import { MdOutlineCalendarToday } from "react-icons/md";
// import { LuClock4 } from "react-icons/lu";
import { FaCircle } from "react-icons/fa6";

const data = [
  {
    name: "Campaign Data Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 40,
  },
  {
    name: "Customer Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 35,
  },
  {
    name: "Insurance Data Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 25,
  },
  {
    name: "Social Media Data Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 20,
  },
  {
    name: "Data Lake Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 15,
  },
  {
    name: "Data Warehouse Pipeline",
    date: "7 Sep 2024",
    time: "12.16",
    changes: 5,
  },
];

const MappingChanges = () => {
  // Custom tooltip component
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, changes } = payload[0].payload;

      return (
        <div
          style={{
            position: "relative",
            backgroundColor: "rgba(0, 0, 0, 0.7)", // Transparent black background
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "7px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            color: "white",
            fontSize: "10px",
            width: "140px",
          }}
        >
          <p style={{ margin: 0, paddingBottom: 3 }}>{name}</p>
          <hr />
          <div className="py-1">
            {/* <div
            className="flex gap-1 items-center"
            style={{ paddingTop: "3px" }}
          >
            <span>
              <MdOutlineCalendarToday size={10} />
            </span>
            <span>{date}</span>
          </div> */}
            {/* <div
            className="flex gap-1 items-center "
            style={{ paddingTop: "3px" }}
          >
            <span>
              <LuClock4 size={10} />
            </span>
            <span>{time}</span>
          </div> */}
            <div
              className="flex gap-1 items-center "
              style={{ paddingTop: "3px" }}
            >
              <span className="flex gap-1 items-center ">
                <span>
                  <FaCircle color="#0078C5" />
                </span>
                <span>Changes :</span>
              </span>
              <span>{changes}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <SubTitle title="Number of changes in Pipeline" showDropdown={false} />
      <div className="p-3 min-h-20 h-64">
        <ResponsiveContainer width="100%" height={230}>
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: 5,
              left: 5,
              bottom: 5,
            }}
            barSize={15}
          >
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{
                fontSize: 9,
                width: 80,
                fill: "#9E9E9E",
              }}
              interval={0} // Show all labels
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{
                fontSize: 9,
                width: 50,
                fill: "#9E9E9E",
              }}
            />
            <text
              x={60} // Adjust this value to position it correctly
              y={160} // Adjust for vertical positioning
              textAnchor="middle"
              fill="#9E9E9E"
              fontSize="10px"
              transform="rotate(-90, 10, 150)" // Rotate the text to be vertical
            >
              Change
            </text>
            <Tooltip content={<CustomTooltip />} />

            <CartesianGrid stroke="#f5f5f5" strokeDasharray="" />
            <Bar dataKey="changes" fill="#0078C5" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MappingChanges;
